import { forwardRef } from "react";
import { cn } from "@/lib/utils";

const TextareaField = forwardRef(function TextareaField({ label, error, className = "", rows = 4, ...props }, ref) {
  return (
    <label className="block text-left">
      {label ? <span className="mb-1.5 block text-sm font-semibold text-brand-ink">{label}</span> : null}
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          "w-full resize-y rounded-xl border bg-white px-4 py-2.5 text-sm text-brand-ink outline-none transition placeholder:text-slate-400 focus:border-brand-primary focus:ring-2 focus:ring-brand-primary/20",
          error ? "border-red-500 focus:border-red-500 focus:ring-red-500/20" : "border-slate-200",
          className
        )}
        {...props}
      />
      {error ? <span className="mt-1 block text-xs font-semibold text-red-600">{error}</span> : null}
    </label>
  );
});

export default TextareaField;
